module.exports = __webpack_public_path__ + "img/mobile-iphone.66167be6.png";